var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#BFDAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3164 17.7109L15.8633 17.1914C15.9727 17.0547 15.9727 16.8359 15.8633 16.7266L10.9141 11.75L15.8633 6.80078C15.9727 6.69141 15.9727 6.47266 15.8633 6.33594L15.3164 5.81641C15.1797 5.67969 14.9883 5.67969 14.8516 5.81641L9.10938 11.5312C9 11.668 9 11.8594 9.10938 11.9961L14.8516 17.7109C14.9883 17.8477 15.1797 17.8477 15.3164 17.7109Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.91fed6c38bafc7b0fc92c9595ec1e2b3.svg";
export { ForwardRef as ReactComponent };